// Homepage copy from the Figma design. SAMPLE content: VEYSO to review and replace.
// Names, quotes and prices below are placeholders from the design file, not approved claims.

export const HERO = {
  eyebrow: "Supplements · Biomarker testing · Telehealth",
  title: "Your home for longevity care",
  subtitle: "A more connected approach to wellness",
  // Put the files in public/media/. If they are missing the hero shows a warm gradient instead.
  video: "/media/hero.mp4",
  poster: "/media/hero-poster.jpg",
};

export const TRUST = [
  ["stethoscope", "Board-certified physicians"],
  ["flask", "CLIA-certified labs"],
  ["microscope", "Third-party tested for purity"],
  ["lock", "HIPAA-compliant"],
  ["shield", "cGMP-certified facilities"],
  ["plus", "Licensed U.S. pharmacies"],
  ["pin", "Available in all 50 states"],
];

export const PRODUCT_TAGS = ["Daily foundation", "Sleep & recovery", "Gut health"];

export const SHOP_VALUES = [
  ["leaf", "Vetted for quality & safety"],
  ["microscope", "Backed by real evidence"],
  ["person", "Expert curated picks"],
];

export const TEST_ICONS = { gut: "leaf", dna: "microscope", blood: "drop", hormone: "sun", epigenetic: "microscope", specialty: "sun" };

export const EXPERTS = [
  { name: "Dylan Gemelli, VEYSO Co-Founder", role: "Health educator · Host of The Dylan Gemelli Podcast", photo: "" },
  { name: "Expert name, MD", role: "Board-certified · XX years in hormone health", photo: "" },
  { name: "Expert name, PharmD", role: "Clinical pharmacist · Peptide protocols", photo: "" },
];

export const STANDARD = {
  kicker: "The VEYSO Standard",
  title: "Not everything meets our standard.",
  sub: "We turn down more than we sell.",
  pillars: [
    ["microscope", "Evidence", "Backed by peer-reviewed research"],
    ["shield", "Quality", "Third-party tested, every batch"],
    ["dollar", "Value", "Fair prices, no upsells"],
  ],
  story: {
    kicker: "Member story",
    quote: "“Every doctor said I was fine. VEYSO showed me why I didn’t feel fine, and what to do about it.”",
    name: "Shaylee, 35",
    role: "Early access member · VEYSO Precision",
  },
};

export const CARE = {
  member: {
    kicker: "VEYSO Member", title: "Essential support for your health journey.",
    text: "Ongoing guidance, expert insights, and exclusive savings to help you take the next step.",
    perks: ["Member pricing on products", "Exclusive content & education", "Personalized recommendations", "Priority access to new offerings"],
    price: "$XX", cta: "Become a Member", to: "/membership",
  },
  plus: {
    kicker: "VEYSO+", title: "A more personalized, complete path.",
    text: "Advanced testing, personalized care, and ongoing support for long-term health.",
    perks: ["Everything in VEYSO Member", "Comprehensive biomarker testing", "Personalized care plans", "Ongoing provider support", "Advanced treatment options"],
    price: "$XX", cta: "Join VEYSO+", to: "/membership",
  },
  values: [["percent", "Member pricing"], ["person", "Expert guidance"], ["pulse", "Personalized results"]],
};

export const YOU = {
  kicker: "VEYSO YOU",
  title: "A little knowledge", em: "changes everything.",
  text: "Live webinars with leading health experts, plus educational programs and guides.",
  card: { pill: "Live + on demand", title: "Get invites to live webinars", text: "Be first to know about upcoming webinars, new programs, and guides.",
    items: [["play", "Live expert webinars"], ["hourglass", "Educational programs"], ["leaf", "Practical guides"]] },
};

export const HOME_FAQS = [
  { q: "How does hormone care work?", a: "You start with labs, review them with a licensed clinician, and get a personalized plan. Treatment is prescribed only when clinically appropriate, and members retest and adjust over time." },
  { q: "Are peptides safe and legal?", a: "Sample answer. VEYSO’s clinical team will provide approved wording." },
  { q: "How do prescriptions and refills work?", a: "Sample answer. VEYSO’s clinical team will provide approved wording." },
  { q: "Where do I get my blood drawn?", a: "You choose a partner lab location near you, or an at-home draw where available." },
  { q: "Can I use HSA or FSA funds?", a: "Sample answer. Eligibility will be confirmed before launch." },
];

export const CLOSING = { kicker: "Ready when you are", title: "Your next chapter starts with one step.", image: "/media/closing.jpg" };
